export const mapCameraState = {};
